import { createFileRoute } from '@tanstack/react-router';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutHero from '../components/about/AboutHero';
import WhatIsCoRATES from '../components/about/WhatIsCoRATES';
import WhoIsCoRATESFor from '../components/about/WhoIsCoRATESFor';
import HowDidCoRATESStart from '../components/about/HowDidCoRATESStart';
import WhoDevelopedCoRATES from '../components/about/WhoDevelopedCoRATES';
import CTA from '../components/CTA';
import { config } from '../lib/config';

const pageUrl = `${config.appUrl}/about`;
const title = 'About CoRATES - The Team Behind the Appraisal Platform';
const description =
  'Meet the team behind CoRATES: a research synthesis expert and a software engineer building tools for rigorous, transparent study appraisal in evidence synthesis.';

export const Route = createFileRoute('/about')({
  headers: () => ({
    'Cache-Control': 'public, s-maxage=3600, stale-while-revalidate=86400',
  }),
  head: () => ({
    meta: [
      { title },
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: pageUrl },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ],
    links: [{ rel: 'canonical', href: pageUrl }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className='min-h-screen bg-linear-to-b from-blue-50/30 to-white'>
      <Navbar />
      <main>
        <AboutHero />
        <WhatIsCoRATES />
        <WhoIsCoRATESFor />
        <HowDidCoRATESStart />
        <WhoDevelopedCoRATES />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
